import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

// ============================================================================
// Futár rendelés (pickup igénylés) — DTO-k a 23-logic.js courierVals
// state-jéből levezetve (11-futar-rendeles.html).
// ============================================================================

export type CourierPickupDay = 'today' | 'tomorrow';

export interface CourierPickup {
  id: number;
  day: CourierPickupDay;
  /** dobozok száma (1-5) */
  boxes: number;
  /** az elküldött email szövege */
  emailBody: string;
  /** ISO dátum — mikor ment el az igénylés */
  sentAt: string;
  /** melyik napra szól ('YYYY-MM-DD') */
  pickupDate: string;
}

export interface CreateCourierPickupRequest {
  day: CourierPickupDay;
  boxes: number;
}

@Injectable({ providedIn: 'root' })
export class CourierPickupsService {

  constructor(private http: HttpClient) {}

  /** GET courier-pickups — korábbi igénylések (legfrissebb elöl) */
  getPickups(): Observable<CourierPickup[]> {
    return this.http.get<CourierPickup[]>('courier-pickups');
  }

  /** POST courier-pickups — pickup igénylés, a backend küldi az emailt a Spring GDS-nek */
  createPickup(request: CreateCourierPickupRequest): Observable<CourierPickup> {
    return this.http.post<CourierPickup>('courier-pickups', request);
  }
}
